// sort-imports-ignore
import '@utils/datadog/datadog-instrument';
import '@utils/sentry/sentry-instrument';

import { loadDevMessages, loadErrorMessages } from '@apollo/client/dev';
import { Environment, getEnvironment } from '@utils/environment';
import * as ReactDOM from 'react-dom/client';

import { App } from './app';
import './index.css';

// Reload the page if there is a preload error, see https://vitejs.dev/guide/build#load-error-handling
window.addEventListener('vite:preloadError', (event: Event) => {
  event.preventDefault();

  window.location.reload(); // Reload the page to load main script again
});

// Adds GraphQL detailed message in dev environment
if (getEnvironment() === Environment.LOCAL) {
  loadDevMessages();
  loadErrorMessages();
}

const root = document.getElementById('root');
if (!root) {
  throw new Error('Root element not found');
}
ReactDOM.createRoot(root).render(<App />);
